import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'pv3-silence-alert',
  templateUrl: 'silence-alert.component.html',
  styleUrls: ['./silence-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class V3SilenceAlertComponent {}
